import { render, staticRenderFns } from "./EventArrows.vue?vue&type=template&id=cafa0032"
import script from "./EventArrows.vue?vue&type=script&lang=js"
export * from "./EventArrows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports